import React, { useEffect, useState } from "react"
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { injectIntl } from "react-intl"

import { Carsharing } from "@ridecell/web-sdk"

import TripCard from "./TripCard"
import messages from "./messages"

const useStyles = makeStyles((theme) => ({
  pastTrips: {
    maxHeight: "320px",
    overflowY: "scroll",
  },
  tripCard: {
    width: "100%",
  },
  tripImage: {
    height: "100px",
    objectFit: "fill",
  },
  upcomingTrips: {
    maxHeight: "320px",
    overflowY: "scroll",
  },
}))

const MyTrips = ({ customer, intl: { formatMessage }, rentalMode }) => {
  const classes = useStyles()

  const [currentTripLoading, setCurrentTripLoading] = useState(false)
  const [currentTrip, setCurrentTrip] = useState({})
  const [pastTrips, setPastTrips] = useState([])
  const [pastTripsLoading, setPastTripsLoading] = useState(false)
  const [upcomingTrips, setUpcomingTrips] = useState([])
  const [upcomingTripsLoading, setUpcomingTripsLoading] = useState(false)

  // Get Past Trips
  useEffect(() => {
    if (!customer) {
      return setPastTrips([])
    }
    setPastTripsLoading(true)
    // GET Past Trips
    Carsharing.getTrips({
      is_cancelled: false,
      in_progress: false,
      page: 1,
      page_size: 25,
      past: true,
      type: "RENTAL",
      ...rentalMode,
    })
      .then((trips) => {
        setPastTrips(trips)
        setPastTripsLoading(false)
      })
      .catch((error) => {
        alert(error)
        setPastTripsLoading(false)
      })
  }, [customer, rentalMode])

  // GET Current Trip
  const getCurrentTrip = () => {
    setCurrentTripLoading(true)
    Carsharing.getRental({ in_progress: true, ...rentalMode })
      .then((trip) => {
        if (trip) setCurrentTrip(trip)
        setCurrentTripLoading(false)
      })
      .catch((error) => {
        alert(error)
        setCurrentTripLoading(false)
      })
  }
  useEffect(() => {
    if (!customer) {
      return setCurrentTrip({})
    }
    getCurrentTrip()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, rentalMode])

  // Get Upcoming Trips
  const getUpcomingTrips = () => {
    setUpcomingTripsLoading(true)
    // GET Upcoming Trips
    Carsharing.getTrips({
      is_cancelled: false,
      in_progress: false,
      page: 1,
      page_size: 25,
      type: "SCHEDULED_RENTAL_REQUEST",
      upcoming: true,
      ...rentalMode,
    })
      .then((trips) => {
        setUpcomingTrips(trips)
        setUpcomingTripsLoading(false)
      })
      .catch((error) => {
        alert(error)
        setUpcomingTripsLoading(false)
      })
  }
  useEffect(() => {
    if (!customer) {
      return setUpcomingTrips([])
    }
    getUpcomingTrips()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, rentalMode])

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <Card>
          <CardHeader
            title={formatMessage(messages.currentTrip)}
            titleTypographyProps={{ variant: "h6" }}
          />
          <CardContent>
            {currentTripLoading && (
              <Grid
                alignContent="center"
                justify="center"
                container
                direction="column"
              >
                <Grid item>
                  <CircularProgress />
                </Grid>
              </Grid>
            )}
            {!currentTripLoading &&
              !currentTrip.id &&
              formatMessage(messages.noCurrentTrip)}
            {currentTrip.id && (
              <TripCard key={currentTrip.id} trip={currentTrip} current />
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Card>
          <CardHeader
            title={formatMessage(messages.upcomingTrips)}
            titleTypographyProps={{ variant: "h6" }}
          />
          <CardContent className={classes.upcomingTrips}>
            {upcomingTripsLoading && (
              <Grid
                alignContent="center"
                justify="center"
                container
                direction="column"
              >
                <Grid item>
                  <CircularProgress />
                </Grid>
              </Grid>
            )}
            {!upcomingTripsLoading &&
              upcomingTrips.length === 0 &&
              formatMessage(messages.noUpcomingTrips)}
            <Grid container spacing={1}>
              {upcomingTrips.length > 0 &&
                upcomingTrips.map((trip) => (
                  <TripCard
                    getUpcomingTrips={getUpcomingTrips}
                    key={trip.id}
                    trip={trip}
                    upcoming
                  />
                ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Card>
          <CardHeader
            title={formatMessage(messages.pastTrips)}
            titleTypographyProps={{ variant: "h6" }}
          />
          <CardContent className={classes.pastTrips}>
            {pastTripsLoading && (
              <Grid
                alignContent="center"
                justify="center"
                container
                direction="column"
              >
                <Grid item>
                  <CircularProgress />
                </Grid>
              </Grid>
            )}
            {!pastTripsLoading &&
              pastTrips.length === 0 &&
              formatMessage(messages.noPastTrips)}
            <Grid container spacing={1}>
              {pastTrips.length > 0 &&
                pastTrips.map((trip) => <TripCard key={trip.id} trip={trip} />)}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default injectIntl(MyTrips)
